import { render, staticRenderFns } from "./PlanBoxBasic.vue?vue&type=template&id=2c4f1c58&scoped=true&"
import script from "./PlanBoxBasic.vue?vue&type=script&lang=js&"
export * from "./PlanBoxBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4f1c58",
  null
  
)

export default component.exports